import { URL_ENDPOINTS } from '../../constants';
import { axiosInstance as Api } from '../../utils/api-helper';
import { Cities, Keys } from './types';

const AppConfigService = {
  getCountryData: (): Promise<Keys[]> => {
    return Api.get(URL_ENDPOINTS.COUNTRY_LIST);
  },

  getContractTypes: (): Promise<Keys[]> => {
    return Api.get(URL_ENDPOINTS.CONTRACT_TYPE);
  },

  getCity: (postalCode: string): Promise<Cities[]> => {
    return Api.get(URL_ENDPOINTS.CITY, {
      params: {
        postal_code: postalCode,
      },
    });
  },
  getRoadTypes: (): Promise<Keys[]> => {
    return Api.get(URL_ENDPOINTS.ROAD_TYPE_LIST);
  },
};

export default AppConfigService;
